import { render, staticRenderFns } from "./XMLFormatter.vue?vue&type=template&id=07b26744"
import script from "./XMLFormatter.vue?vue&type=script&lang=js"
export * from "./XMLFormatter.vue?vue&type=script&lang=js"
import style0 from "./XMLFormatter.vue?vue&type=style&index=0&id=07b26744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports